import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "page",
  style: {"padding":"16px 12px 0px 12px"}
}
const _hoisted_2 = { style: {"padding":"16px 10px 0px 10px"} }
const _hoisted_3 = { style: {"color":"white","font-size":"2.5vh","font-style":"blod","padding-bottom":"1vh"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"center","padding-top":"5vh"} }
const _hoisted_5 = {
  class: "d-flex flex-column justify-center items-center circle-slot",
  style: {"height":"100%"}
}
const _hoisted_6 = { class: "health-container" }
const _hoisted_7 = { class: "health-item health-itemFont" }
const _hoisted_8 = { class: "health-num" }
const _hoisted_9 = { class: "health-otherFont" }
const _hoisted_10 = { class: "health-item health-itemFont" }
const _hoisted_11 = { class: "health-num" }
const _hoisted_12 = { class: "health-otherFont" }
const _hoisted_13 = { style: {"font-size":"2.5vh"} }
const _hoisted_14 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_15 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_16 = { class: "health-iconFontBody" }
const _hoisted_17 = { class: "health-iconFontColor" }
const _hoisted_18 = { style: {"display":"inline-block"} }
const _hoisted_19 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_20 = { class: "health-iconFontBody" }
const _hoisted_21 = { class: "health-iconFontColor" }
const _hoisted_22 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_23 = { class: "health-iconFontBody" }
const _hoisted_24 = { class: "health-iconFontColor" }
const _hoisted_25 = { style: {"display":"inline-block"} }
const _hoisted_26 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_27 = { class: "health-iconFontBody" }
const _hoisted_28 = { class: "health-iconFontColor" }
const _hoisted_29 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_30 = { class: "health-iconFontBody" }
const _hoisted_31 = { class: "health-iconFontColor" }
const _hoisted_32 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_33 = { class: "health-iconFontBody" }
const _hoisted_34 = { class: "health-iconFontColor" }
const _hoisted_35 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_36 = { class: "health-iconFontBody" }
const _hoisted_37 = { class: "health-iconFontColor" }
const _hoisted_38 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_39 = { class: "health-iconFontBody" }
const _hoisted_40 = { class: "health-iconFontColor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_circle = _resolveComponent("van-circle")!
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createBlock(_KeepAlive, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_my_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_my_card_body, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("health.healthEquipment")), 1),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "health-horizontal-line" }, null, -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_van_circle, {
                      "current-rate": $setup.convertToPercentage($setup.count),
                      "layer-color": "rgba(255,255,255,.05)",
                      color: $setup.percentFormat($setup.count).style,
                      size: "18vh",
                      "stroke-width": "100",
                      onClick: $setup.startHealthTest
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({
                        color: $setup.percentFormat($setup.count).style,
                        fontWeight: 'bold',
                        fontSize: '25px'
                      }),
                            class: "score-content"
                          }, _toDisplayString($setup.count ? Math.floor($setup.convertToPercentage($setup.count)) : 0) + "% ", 5),
                          _createElementVNode("p", {
                            style: _normalizeStyle({
                        color: $setup.percentFormat($setup.count).style
                      })
                          }, _toDisplayString($setup.percentFormat($setup.count).desc) + " " + _toDisplayString($setup.disconnectFlag ? "连接断开" : "") + " " + _toDisplayString($setup.abnormalFlag ? "采集数据异常" : ""), 5)
                        ])
                      ]),
                      _: 1
                    }, 8, ["current-rate", "color", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.heartRate
                        ? $setup.healthRealtimeData.heartRate
                        : "--"), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", null, "BMP", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("health.heartRateStatus")), 1)
                      ])
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "health-item health-itemFont" }, "|", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.spo2
                        ? $setup.healthRealtimeData.spo2
                        : "--"), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", null, "%", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("health.bloodOxygenStatus")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("blockquote", null, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("health.PulseWave")), 1)
                    ]),
                    _createElementVNode("div", {
                      ref: $setup.setRef,
                      style: {"height":"28vh","width":"100%"}
                    }, null, 512),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", {
                          style: {"background-color":"#328cb5"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_bk.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.bk
                            ? $setup.healthRealtimeData.bk
                            : "0") + "% ", 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("health.microcirculation")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", {
                          style: {"background-color":"#c06e2c"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_rmssd.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rsv
                            ? $setup.healthRealtimeData.rsv[3]
                            : "0"), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("health.systolicPressure")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", {
                          style: {"background-color":"#b1a62b"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_dbp.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rsv
                            ? $setup.healthRealtimeData.rsv[4]
                            : "0"), 1),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("health.diastolicPressure")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", {
                          style: {"background-color":"#1e60a3"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_rr.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rra
                            ? $setup.healthRealtimeData.rra.reduce(
                                (acc, curr) => acc + curr,
                                0
                              )
                            : "0"), 1),
                          _cache[6] || (_cache[6] = _createTextVNode(" RR ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", {
                          style: {"background-color":"#993030"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_sdnn.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.sdnn
                            ? $setup.healthRealtimeData.sdnn
                            : "0"), 1),
                          _cache[8] || (_cache[8] = _createTextVNode(" SDNN ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", {
                          style: {"background-color":"#2fa988"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_rmssd.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rmssd
                            ? $setup.healthRealtimeData.rmssd
                            : "0"), 1),
                          _cache[10] || (_cache[10] = _createTextVNode(" RMSSD ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", {
                          style: {"background-color":"#284987"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_nn50.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.nn50
                            ? $setup.healthRealtimeData.nn50
                            : "0"), 1),
                          _cache[12] || (_cache[12] = _createTextVNode(" NN50 ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", {
                          style: {"background-color":"#c1832a"},
                          class: "health-iconItemImg"
                        }, [
                          _createElementVNode("img", {
                            src: "/images/icon/icon_pnn50.png",
                            width: "25",
                            height: "25",
                            alt: "Report Icon"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.pnn50
                            ? $setup.healthRealtimeData.pnn50
                            : "0"), 1),
                          _cache[14] || (_cache[14] = _createTextVNode(" PNN50 ", -1))
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 1024))
}